import axios from 'axios'

const SERVER_URL = 'https://rivernet.lk/_kaluganga-overview/server/api';

const ApiPublic = axios.create({
  baseURL: SERVER_URL,
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json'
  }
})

export { ApiPublic };
